export default __webpack_public_path__ + "static/media/helm-clock.f716b300.svg";